// extracted by mini-css-extract-plugin
module.exports = {"table":"MotivationTable_table__hnuQ-","table__body":"MotivationTable_table__body__1uiI-"};